document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.more_about').forEach(function(button) {
    button.addEventListener('click', function() {
      var card = button.closest('.card_team');
      var descriptionBox = card.querySelector('.description_box');
      var fadeOut = card.querySelector('.fade_out');
      var buttonTextSpan = button.querySelector('.button-text');
      var svgIcon = button.querySelector('svg');

      if (descriptionBox.style.opacity === '0' || descriptionBox.style.opacity === '') {
        descriptionBox.style.opacity = '1';
        fadeOut.style.opacity = '1'; // Fade in the overlay
        buttonTextSpan.textContent = 'CLOSE'; // Change button text to "Close"
        buttonTextSpan.style.color = 'white'; // Set text color to white
        svgIcon.style.transform = 'rotate(45deg)'; // Rotate SVG icon 40 degrees
        descriptionBox.style.pointerEvents = 'all';
        fadeOut.style.pointerEvents = 'all';
        
      } else {
        descriptionBox.style.opacity = '0';
        fadeOut.style.opacity = '0'; // Fade out the overlay
        setTimeout(function() {
          descriptionBox.style.opacity = '0'; // Ensure opacity stays at 0 after fade-out
          descriptionBox.style.pointerEvents = 'none'; // Disable pointer-events after fade-out
          fadeOut.style.pointerEvents = 'none'; // Disable pointer-events after fade-out
        }, 300); // Adjust the duration to match the transition duration in CSS
        buttonTextSpan.textContent = 'ABOUT'; // Change button text back to "About"
        buttonTextSpan.style.color = ''; // Reset text color to default (if previously changed)
        svgIcon.style.transform = ''; // Reset SVG rotation to default
      }
    });
     // Add event listener for SVG click
     button.querySelector('svg').addEventListener('click', function(event) {
      // Prevent the click event from propagating to the button element
      event.stopPropagation();
      
      // Get the SVG element and rotate it 40 degrees
      var svgIcon = button.querySelector('svg');
      svgIcon.style.transform = 'rotate(45deg)';
    });
  });
});

